import { useEffect, useState } from "react";
import { Sort } from "../../modules/search/@types";

export type Paging = {
  currentPage: number;
  pageSize: number;
};

export const DEFAULT_INITIAL_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 20;

type UsePagingAndSortingInitialState = {
  paging?: Partial<Paging>;
  sort?: Partial<Sort>;
};

const usePagingAndSorting = (
  initialState?: UsePagingAndSortingInitialState
) => {
  const [currentPage, setCurrentPage] = useState(
    initialState?.paging?.currentPage ?? DEFAULT_INITIAL_PAGE
  );
  const [pageSize, setPageSize] = useState(
    initialState?.paging?.pageSize ?? DEFAULT_PAGE_SIZE
  );
  const [sortField, setSortField] = useState(initialState?.sort?.field);
  const [sortDirection, setSortDirection] = useState(
    initialState?.sort?.direction
  );

  useEffect(() => {
    setCurrentPage(initialState?.paging?.currentPage ?? DEFAULT_INITIAL_PAGE);
    setPageSize(initialState?.paging?.pageSize ?? DEFAULT_PAGE_SIZE);
    setSortField(initialState?.sort?.field);
    setSortDirection(initialState?.sort?.direction);
  }, [
    initialState?.paging?.currentPage,
    initialState?.paging?.pageSize,
    initialState?.sort?.field,
    initialState?.sort?.direction
  ]);

  const setSort = (updatedSort: Sort) => {
    setSortField(updatedSort?.field);
    setSortDirection(updatedSort?.direction);
  };

  const setPaging = (updatedPaging: Paging) => {
    setCurrentPage(updatedPaging?.currentPage);
    setPageSize(updatedPaging?.pageSize);
  };

  const parseAndSetPaging = (
    currentPageString: string,
    pageSizeString: string
  ) => {
    const parsedCurrentPage = parseInt(currentPageString, 10);
    const parsedPageSize = parseInt(pageSizeString, 10);

    setPaging({
      currentPage: isNaN(parsedCurrentPage)
        ? DEFAULT_INITIAL_PAGE
        : parsedCurrentPage,
      pageSize: isNaN(parsedPageSize) ? DEFAULT_PAGE_SIZE : parsedPageSize
    });
  };

  return {
    paging: {
      currentPage,
      pageSize
    },
    sort: {
      field: sortField,
      direction: sortDirection
    },
    setSort,
    setPaging,
    parseAndSetPaging
  };
};

export default usePagingAndSorting;
